export var figures = {
  gen_time: {
    factor: 500
  },
  gen_map_time: {
    factor: 100
  },
  pred_scatter: {
    factor: 500
  },
  gen_type_bar: {
    factor: 10
  },
  demand_disaggregation: {
    factor: 500
  },
  capacity_plant_resource: {
    factor: 500
  },
  market_price: {
    factor: 500
  },
  fuel_price: {
    factor: 500
  },
  gen_type_bar_yearly: {
    factor: 10
  },
  energy_per_unit: {
    factor: 500
  },
  forecasts: {
    factor: 700
  }
};